import React from 'react'
import WelomeComponent from './component/WelomeComponent'

function App() {
  return (
    <div>
      <WelomeComponent />
    </div>
  )
}

export default App
